import * as React from "react";
import classNames from "classnames";

// Styles
import "./Loader.scss";

interface ILoader {
  className?: string;
}

const Loader: React.FunctionComponent<ILoader> = ({ className }: ILoader) => {
  const loaderClassNames = classNames("loader", {
    [`${className}`]: className,
  });

  return (
    <div className={loaderClassNames}>
      <div className="bouncingLoader">
        <div />
      </div>
    </div>
  );
};

export default Loader;
